var _excluded = ["trackColor"],
    _excluded2 = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import styledPropTypes from '@styled-system/prop-types';
import { color, background } from 'styled-system';
import { shouldForwardProp } from '../../utils';
import Text from '../Text/Text';
import { strictSpace } from '../../utils';
import ProgressBar from './../ProgressBar/ProgressBar';
var tileHeaderString = 'TileHeader';
var tileProgress = 'TileProgress';
var iconSize = '2rem';
var StyledHeader = styled.div.withConfig({
  displayName: "Tile__StyledHeader",
  componentId: "sc-1qgn16a-0"
})(["color:", ";", " > div:first-of-type{display:flex;align-items:center;svg{flex:0 0 ", ";height:", ";margin-right:", ";}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.textPrimary;
}, strictSpace, iconSize, iconSize, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.xs;
});
StyledHeader.defaultProps = {
  py: 's',
  px: 'm'
};

var Header = function Header(_ref3) {
  var icon = _ref3.icon,
      as = _ref3.as,
      title = _ref3.title,
      subtitle = _ref3.subtitle;
  return /*#__PURE__*/React.createElement(StyledHeader, null, /*#__PURE__*/React.createElement("div", null, icon, /*#__PURE__*/React.createElement(Text.H4, {
    as: as,
    color: "textPrimary",
    fontWeight: "bold"
  }, title)), subtitle && /*#__PURE__*/React.createElement(Text, {
    mt: "min",
    color: "textSecondary",
    as: "div"
  }, subtitle));
};

Header.defaultProps = {
  as: 'h3'
};
Header.displayName = tileHeaderString;
var StyledProgressBar = styled.div.withConfig({
  displayName: "Tile__StyledProgressBar",
  componentId: "sc-1qgn16a-1"
})(["position:absolute;left:0;right:0;bottom:0;transform:translateY(57%);"]);

var Progress = function Progress(_ref4) {
  var trackColor = _ref4.trackColor,
      rest = _objectWithoutProperties(_ref4, _excluded);

  return /*#__PURE__*/React.createElement(StyledProgressBar, null, /*#__PURE__*/React.createElement(ProgressBar, _extends({
    trackColor: trackColor
  }, rest)));
};

Progress.defaultProps = {
  trackColor: 'transparent'
};
Progress.displayName = tileProgress;
/**
 * Renders a stash tile.
 */

var StyledTile = styled.section.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Tile__StyledTile",
  componentId: "sc-1qgn16a-2"
})(["border-radius:", ";overflow:", ";position:relative;", " ", " ", ""], function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius.radius8;
}, function (_ref6) {
  var overflowVisible = _ref6.overflowVisible;
  return overflowVisible ? 'visible' : 'hidden';
}, strictSpace, color, background);

var Tile = function Tile(_ref7) {
  var children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, _excluded2);

  var _React$Children$toArr = React.Children.toArray(children),
      _React$Children$toArr2 = _slicedToArray(_React$Children$toArr, 1),
      firstChild = _React$Children$toArr2[0];

  var hasHeader = firstChild && firstChild.type && firstChild.type.displayName === tileHeaderString;

  if (hasHeader) {
    return /*#__PURE__*/React.createElement(StyledTile, _extends({}, rest, {
      p: "none"
    }), children);
  }

  return /*#__PURE__*/React.createElement(StyledTile, _extends({}, rest, {
    children: children
  }));
};

Tile.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
  overflowVisible: PropTypes.bool
}, styledPropTypes.space), {}, {
  /** backgroundColor can reference any of the [color variables](/#/Variables?id=colors) */
  backgroundColor: PropTypes.string
}, styledPropTypes.color), styledPropTypes.background), {}, {
  /** specifying background will override the more granular background props */
  background: PropTypes.string
});
Tile.defaultProps = {
  backgroundColor: 'bgSecondary',
  mb: 'm',
  p: 'm'
};
Tile.Header = Header;
Tile.Progress = Progress;
/** @component */

export default Tile;